const dummyPosts = [
  {
    name: "Alex Rivera",
    description: "Senior Frontend Architect | React & Next.js Specialist",
    caption:
      "🚀 Next.js 15 is changing the game for server-side rendering! The speed improvements with the new caching strategies are insane. If you haven't tried the new App Router features, you're missing out on a lot of developer experience improvements.\n\nWhat are your thoughts on the new partial prerendering?",
    image: "", // user will attach
    video: "",
    date: "2026-03-01",
    time: "10:30 AM",
  },
  {
    name: "Sarah Chen",
    description: "AI Researcher @ DeepMind | Engineering Lead",
    caption:
      "🤖 LLMs are no longer just for chat. We are seeing a massive shift towards Agentic Workflows where AI can actually perform multi-step tasks autonomously. \n\nIntegrating these agents into React apps is where the real magic happens. Check out how we use Vercel AI SDK to build streaming interfaces for complex agents.",
    image: "", // user will attach
    video: "",
    date: "2026-02-28",
    time: "02:15 PM",
  },
  {
    name: "Marcus Thorne",
    description: "UI/UX Designer | Design Systems Junkie",
    caption:
      "Glassmorphism + Bento Grids = The UI trend of 2026? 🎨\n\nI've been experimenting with subtle blur effects and card layouts for a new SaaS project. It feels premium and extremely clean. \n\nWhat do you guys think? Is the Bento grid here to stay or just a passing trend?",
    image: "", // user will attach
    video: "",
    date: "2026-02-25",
    time: "09:00 AM",
  },
  {
    name: "Elena Vance",
    description: "Full Stack Developer | AI Enthusiast",
    caption:
      "Just integrated GPT-5 into my latest project for real-time code reviews. The level of reasoning is just phenomenal. It's like having a senior dev sitting right next to you at all times. \n\nThe future of coding is collaborative with AI. 💻✨",
    image: "", // user will attach
    video: "",
    date: "2026-02-20",
    time: "11:45 AM",
  },
];

export default dummyPosts;
